"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCodeType = exports.initQRStyle = exports.dynamicQRLeft = exports.qrCodeIsExpired = void 0;
const moment = require("moment");
const dateTime_util_1 = require("./dateTime.util");
const qrgenerator_enum_1 = require("../enums/qrgenerator.enum");
const qrCodeIsExpired = ({ creation_date, alacarte_benefits }) => {
    if (alacarte_benefits?.expiry.enable) {
        return ((0, dateTime_util_1.timeExpired)(moment(creation_date).add(alacarte_benefits.expiry.unit, alacarte_benefits.expiry.in).format(dateTime_util_1.defaultDateFormat)));
    }
    return false;
};
exports.qrCodeIsExpired = qrCodeIsExpired;
const dynamicQRLeft = (organization) => {
    if (!organization.all_qrs.alacarte) {
        organization.all_qrs.alacarte = 0;
    }
    const result = (organization.subscription_details.subscription.max_dynamic_qrs + organization.all_qrs.alacarte) - organization.all_qrs.dynamic;
    return result >= 0 ? result : 0;
};
exports.dynamicQRLeft = dynamicQRLeft;
const initQRStyle = (qr_encoded_data = "", primary_color = "", dot_color = "", logo_url = "", qr_middle_logo_id = qrgenerator_enum_1.QRLogoSlugs.DEFAULT) => {
    return {
        frame: {
            text: "SCAN ME",
            color: primary_color || "#000000"
        },
        qr_middle_logo_id,
        preview_img: "",
        qr_style: {
            data: qr_encoded_data,
            width: 1000,
            height: 1000,
            image: logo_url,
            margin: 0,
            qrOptions: {
                typeNumber: 0,
                errorCorrectionLevel: qrgenerator_enum_1.QrThemeQrStyleQROptionsErrorCorrectionalLevels.Q,
                mode: qrgenerator_enum_1.QrThemeQrStyleQROptionsModes.Byte
            },
            imageOptions: {
                margin: 0,
                imageSize: 0.5,
                hideBackgroundDots: true,
                crossOrigin: qrgenerator_enum_1.QrThemeQrStyleImageCrossOriginOptions.ANONYMOUS
            },
            dotsOptions: {
                gradient: null,
                color: dot_color || "#000000",
                type: qrgenerator_enum_1.QrThemeCornerOptions.SQUARE,
            },
            cornersSquareOptions: {
                gradient: null,
                color: dot_color || "#000000",
                type: qrgenerator_enum_1.QrThemeCornerOptions.SQUARE,
            },
            // cornersDotOptionsHelper: {
            //   color: "#000000",
            //   gradient: null,
            //   type: "dot"
            // },
            cornersDotOptions: {
                gradient: null,
                color: dot_color || "#000000",
                type: qrgenerator_enum_1.QrThemeCornerOptions.DOT,
            },
            backgroundOptions: {
                color: "#FFFFFF",
                gradient: null
            }
        }
    };
};
exports.initQRStyle = initQRStyle;
const getCodeType = (category) => {
    if (![qrgenerator_enum_1.QrGeneratorNavigatorCategories.SMS, qrgenerator_enum_1.QrGeneratorNavigatorCategories.EMAIL, qrgenerator_enum_1.QrGeneratorNavigatorCategories.URL, qrgenerator_enum_1.QrGeneratorNavigatorCategories.LOCATION, qrgenerator_enum_1.QrGeneratorNavigatorCategories.TEXT, qrgenerator_enum_1.QrGeneratorNavigatorCategories.VCARD, qrgenerator_enum_1.QrGeneratorNavigatorCategories.BITCOIN, qrgenerator_enum_1.QrGeneratorNavigatorCategories.WIFI].includes(category))
        return qrgenerator_enum_1.QrCodeTypes.DYNAMIC;
    return qrgenerator_enum_1.QrCodeTypes.STATIC;
};
exports.getCodeType = getCodeType;
